function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("rect", {
  x: 0.167,
  width: 17.833,
  height: 17.833,
  rx: 2.675,
  fill: "#000"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12.664 4.458H5.132a2.291 2.291 0 00-2.29 2.293v4.073a2.29 2.29 0 002.29 2.292h7.532a2.29 2.29 0 002.29-2.292V6.75a2.292 2.292 0 00-2.29-2.293zm-5.362 6.185V6.931l3.192 1.856-3.192 1.856z",
  fill: "#fff"
});

function SvgYoutubeBlack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}

export default SvgYoutubeBlack;